
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

import formatPriceToTenge from '@/modern/helpers/formatPriceToTenge'

export default defineComponent({
    props: {
        cost: {
            type: [String, null] as PropType<string | null>,
            default: null
        },
    },
    setup() {
        return { formatPriceToTenge }
    }
})
